import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    let contactAccordion = document.querySelectorAll('[id^="contacts_"]');

    contactAccordion.forEach((item)=> {
      item.addEventListener('change', (event) => {
        if(item.checked) {
          contactAccordion.forEach((otherItem)=> {
            otherItem.checked = true;
          })
        } else {
          contactAccordion.forEach((otherItem)=> {
            otherItem.checked = false;
          })
        }
      });
    });


    let consumptionAccordion = document.querySelectorAll('[id^="consumption"]');

    consumptionAccordion.forEach((item)=> {
      item.addEventListener('change', (event) => {
        if(item.checked) {
          consumptionAccordion.forEach((otherItem)=> {
            otherItem.checked = true;
          })
        } else {
          consumptionAccordion.forEach((otherItem)=> {
            otherItem.checked = false;
          })
        }
      });
    });

    let motorAccordion = document.querySelectorAll('[id^="motor_"]');

    motorAccordion.forEach((item)=> {
      item.addEventListener('change', (event) => {
        if(item.checked) {
          motorAccordion.forEach((otherItem)=> {
            otherItem.checked = true;
          })
        } else {
          motorAccordion.forEach((otherItem)=> {
            otherItem.checked = false;
          })
        }
      });
    });

    let featuresAccordion = document.querySelectorAll('[id^="features_"]');

    featuresAccordion.forEach((item)=> {
      item.addEventListener('change', (event) => {
        if(item.checked) {
          featuresAccordion.forEach((otherItem)=> {
            otherItem.checked = true;
          })
        } else {
          featuresAccordion.forEach((otherItem)=> {
            otherItem.checked = false;
          })
        }
      });
    });

    let baseAccordion = document.querySelectorAll('[id^="base_"]');

    baseAccordion.forEach((item)=> {
      item.addEventListener('change', (event) => {
        if(item.checked) {
          baseAccordion.forEach((otherItem)=> {
            otherItem.checked = true;
          })
        } else {
          baseAccordion.forEach((otherItem)=> {
            otherItem.checked = false;
          })
        }
      });
    });


    let extraAccordion = document.querySelectorAll('[id^="extra_"]');

    extraAccordion.forEach((item)=> {
      item.addEventListener('change', (event) => {
        if(item.checked) {
          extraAccordion.forEach((otherItem)=> {
            otherItem.checked = true;
          })
        } else {
          extraAccordion.forEach((otherItem)=> {
            otherItem.checked = false;
          })
        }
      });
    });

  }
}